import { useState, useEffect } from "react";
import { useMatchMedia } from "../../Hooks/useMatchMedia";

const Space = (props) => {
  const isMobile = useMatchMedia();
  
  const widthCheck = (size) => {
    if(size == '0 auto') {
      return 'fit-content';
    }
  }
  
  let pcStyle = {
    margin: props.size[0],
    width: widthCheck(props.size[0]),
  }
  let spStyle = {
    margin: props.size[1],
    width: widthCheck(props.size[1]),
  }
  return(
    <>
      <div
        style={isMobile ? spStyle : pcStyle}
      >
        { props.children }
      </div>
    </>
  )
};

export default Space;